// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"6520291d","455":"ad741b84","977":"cc87d539"}[chunkId] + ".chunk.js";
};